var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 52,
    viewBox: "0 0 90 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89 0.951996H1L1.05819 12.2987L3.23055 15.1693V15.9645L3.67666 16.43L3.23055 18.3503L6.48909 20.1347L6.79943 20.9687L10.1356 24.9255L10.3101 25.8565L11.1635 25.6044L11.6291 26.8069L13.5105 26.4384L13.1225 29.0763L12.3467 31.8111L13.1225 34.7981L11.92 35.574L12.3467 36.9899L11.92 38.1343L13.6075 39.2204L16.032 36.5244L17.0212 37.3196L17.5836 39.7635L20.0082 43.7203L19.6978 45.2914L21.1525 46.2612L22.006 45.5242L23.4413 49.6361L24.702 50.5671L25.6912 49.0349L27.9024 49.6361L29.0273 48.4142L31.8786 49.19L33.3139 48.4142L35.2147 46.5134L37.678 49.4034V43.9725H89V0.951996Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/MT.84bf23033b9746e7260ac76629ac9b67.svg";
export { ForwardRef as ReactComponent };